﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import { applyThemeStyles, JssClass } from "~base/Styling";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import {
    RegisterPageCustomizations,
    RegisterPageDefaultCustomization,
} from "./Customization";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export interface RegisterPageClasses {
    header: string;
    gridAlignment: string;
    radioPadding: string;
    button: string;
}

export interface RegisterPageStyles {
    header?: JssClass;
    gridAlignment?: JssClass;
    radioPadding?: JssClass;
    button?: JssClass;
}

export const useAdditionalStyles = (
    customization?: RegisterPageCustomizations
): RegisterPageClasses =>
    createUseStyles((theme: ConsilioBaseTheme) => {
        const customStyles =
            customization.customStyles ??
            RegisterPageDefaultCustomization.customStyles;

        const styles = {
            header: applyThemeStyles(customStyles.header, {}),
            gridAlignment: applyThemeStyles(customStyles.gridAlignment, {}),
            radioPadding: applyThemeStyles(customStyles.radioPadding, {}),
            button: applyThemeStyles(customStyles.button, {}),
        };

        return styles;
    })();
